import { Box, Flex, Heading, Text, Tooltip } from '@chakra-ui/react';
import {
	ResponsiveContainer,
	LabelList,
	Bar,
	BarChart,
	CartesianGrid,
	XAxis,
	YAxis,
} from 'recharts';

const colores = ['#2F855A', '#D69E2E', '#DD6B20', '#CBD5E0']; // contacto_0_90, 91_120, 120+, sin_contacto

const InmueblesPorResponsableChart = ({ data = [] }) => {
	const alto = Math.max(data.length * 45, 300);

	return (
		<>
			<Heading size='md' mb={2}>
				Inmuebles por responsable (último contacto)
			</Heading>
			<Flex justify='center' gap={8} align='center' wrap='wrap'>
				<Box overflowX='auto' w={'100%'}>
					<Flex minW='700px' gap={8} w={'100%'}>
						<ResponsiveContainer width='100%' height={alto}>
							<BarChart layout='vertical' data={data}>
								<CartesianGrid strokeDasharray='3 3' />
								<XAxis type='number' />
								<YAxis
									type='category'
									dataKey='nombre'
									width={160}
								/>
								<Tooltip />
								<Bar
									dataKey='contacto_0_90'
									stackId='a'
									fill={colores[0]}
								>
									<LabelList
										dataKey='contacto_0_90'
										position='insideRight'
										formatter={value =>
											value > 0 ? value : ''
										}
									/>
								</Bar>
								<Bar
									dataKey='contacto_91_120'
									stackId='a'
									fill={colores[1]}
								>
									<LabelList
										dataKey='contacto_91_120'
										position='insideRight'
										formatter={value =>
											value > 0 ? value : ''
										}
									/>
								</Bar>
								<Bar
									dataKey='contacto_120_plus'
									stackId='a'
									fill={colores[2]}
								>
									<LabelList
										dataKey='contacto_120_plus'
										position='insideRight'
										formatter={value =>
											value > 0 ? value : ''
										}
									/>
								</Bar>
								<Bar
									dataKey='sin_contacto'
									stackId='a'
									fill={colores[3]}
								>
									<LabelList
										dataKey='sin_contacto'
										position='insideRight'
										formatter={value =>
											value > 0 ? value : ''
										}
									/>
								</Bar>
							</BarChart>
						</ResponsiveContainer>
						<Box mb={4} gap={4}>
							<Flex align='center'>
								<Box
									w={3}
									h={3}
									bg={colores[0]}
									borderRadius='full'
									mr={2}
								/>
								<Text fontSize='sm'>
									Último contacto 0 – 90 días
								</Text>
							</Flex>
							<Flex align='center'>
								<Box
									w={3}
									h={3}
									bg={colores[1]}
									borderRadius='full'
									mr={2}
								/>
								<Text fontSize='sm'>
									Último contacto 91 – 120 días
								</Text>
							</Flex>
							<Flex align='center'>
								<Box
									w={3}
									h={3}
									bg={colores[2]}
									borderRadius='full'
									mr={2}
								/>
								<Text fontSize='sm'>
									Último contacto &gt; 120 días
								</Text>
							</Flex>
							<Flex align='center'>
								<Box
									w={3}
									h={3}
									bg={colores[3]}
									borderRadius='full'
									mr={2}
								/>
								<Text fontSize='sm'>Sin contacto</Text>
							</Flex>
						</Box>
					</Flex>
				</Box>
			</Flex>
		</>
	);
};

export default InmueblesPorResponsableChart;
